// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"740":"cca58702","865":"a126bd3b","943":"bdb5f9bc"}[chunkId] + ".chunk.css";
};